import { __extends } from "tslib";
import * as React from 'react';
import { Input, Layout, Cell } from 'wix-style-react';
var CommonInput = /** @class */ (function (_super) {
    __extends(CommonInput, _super);
    function CommonInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (value) {
            _this.props.onChange(value);
        };
        _this.state = {
            value: _this.props.value || '',
        };
        return _this;
    }
    CommonInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, dataHook = _a.dataHook;
        return (React.createElement(Layout, { gap: 0 },
            React.createElement(Cell, { span: 12 },
                React.createElement(Input, { dataHook: dataHook, placeholder: placeholder, onChange: function (e) {
                        return _this.onChange(e.currentTarget.value);
                    }, value: this.props.value }))));
    };
    return CommonInput;
}(React.PureComponent));
export { CommonInput };
//# sourceMappingURL=CommonInput.js.map